import { centered } from '@ui/style/style';
export const getSuccessPageStyles = (previewLayout) => {
    const isPreviewMobile = previewLayout === 'mobile';
    const isPreviewTablet = previewLayout === 'tablet';
    const isPreviewCompact = isPreviewMobile || isPreviewTablet;
    return {
        root: {
            flex: 1,
            width: '100%',
            maxWidth: 720,
            alignSelf: 'center',
            minHeight: 0,
            mx: 'auto',
            px: isPreviewMobile ? 1 : isPreviewTablet ? 1.5 : { xs: 2, md: 3 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            position: 'relative',
            overflowY: 'auto'
        },
        card: {
            position: 'relative',
            zIndex: 1,
            background: '#FFFFFF',
            border: '1px solid #00244D33',
            boxShadow: '0px 40px 56px 0px #00000014, 0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A',
            borderRadius: '16px',
            padding: isPreviewMobile ? 2.5 : isPreviewTablet ? 3 : { xs: 4, sm: 5 },
            width: '100%',
            maxWidth: 640,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: isPreviewCompact ? 2 : 3
        },
        iconWrap: {
            ...centered,
            width: isPreviewCompact ? 64 : 74,
            height: isPreviewCompact ? 64 : 74,
            borderRadius: '50%',
            backgroundColor: '#3192D0',
            color: '#FFFFFF',
            flexShrink: 0
        },
        playIcon: {
            color: '#637381',
            width: isPreviewCompact ? 40 : 48,
            height: isPreviewCompact ? 40 : 48,
            position: 'absolute',
            top: isPreviewCompact ? 8 : 12,
            right: isPreviewCompact ? 8 : 12,
            zIndex: 2,
            background: '#FFFFFF',
            border: '1px solid #00244D33',
            borderRadius: 2,
            ...centered
        },
        title: {
            fontWeight: 400,
            fontSize: isPreviewMobile ? '1.25rem' : isPreviewTablet ? '1.3125rem' : { xs: '1.375rem', sm: '1.5rem' },
            lineHeight: 1.3,
            color: '#00244D',
            width: '100%'
        },
        customMessage: {
            width: '100%',
            padding: 0,
            textAlign: 'center',
            '& img': {
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
                margin: '8px 0'
            },
            '& p': {
                margin: 0,
                fontFamily: 'SuisseIntl',
                color: '#000000'
            },
            '& .ql-size-small': {
                fontSize: '12px !important'
            },
            '& .ql-size-large': {
                fontSize: '24px !important'
            },
            '& .ql-size-huge': {
                fontSize: '32px !important'
            }
        },
        button: {
            textTransform: 'none',
            fontWeight: 500,
            width: '100%',
            maxWidth: 400,
            borderColor: '#00244D33',
            color: '#00244D',
            py: 1.25,
            px: 3,
            '&:hover': {
                borderColor: '#00244D66',
                backgroundColor: '#F9FAFB'
            }
        }
    };
};
export const successPageStyles = getSuccessPageStyles();
